// ======================================================================
// File Name       : ServiceDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { initializeVideoSpeedOptions, serviceEdit, serviceSearch } from '../../actions/ServiceAction';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import CustomLink from '../../components/button/CustomLink';
import ServiceDetail from '../../components/service/ServiceDetail';
import { SERVICE_EDIT } from '../../constants/FunctionConstants';
import { MSG_DEL_SERVICE } from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import { SERVICE } from '../../constants/PathConstants';
import {
  DEFAULT_SELECTED_VIDEO_SPEED_LIST,
  MODE,
  NEW_SERVICE_MANAGEMENT_URL,
  SELECT_TARGET_DATA
} from "../../constants/index";
import { canAccessRoute } from '../../utils/AuthedUtils';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class ServiceDetailContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      service: null,
      enterpriseList: [],
    };
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteOk = this.onDeleteOk.bind(this);
    this.redirectToServicePage = this.redirectToServicePage.bind(this);
  }

  /**
   * Life cycle function
   */
  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      const param = {
        selectTargetData: SELECT_TARGET_DATA.DATA,
        // TODO: send superuser_id or not ?  where get superuser_id
        // superuser_id: JSON.parse(localStorage.getItem('superuser_id')),
        searchInfo: {
          serviceCdList: [match.params.id],
        },
      };
      this.props.dispatch(serviceSearch(param));
    }
  }

  componentWillUnmount() {
    const { videoSpeedArr } = this.props;
    const videoSpeedArrUpadte = [...videoSpeedArr];
    videoSpeedArrUpadte.map((value) => {
      if (!DEFAULT_SELECTED_VIDEO_SPEED_LIST.includes(value.speed)) {
        value.isChecked = false;
      }
    });

    this.props.dispatch(initializeVideoSpeedOptions(videoSpeedArrUpadte));
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { service, match } = nextProps;
    const { serviceInfo, enterpriseList } = service;
    const serviceDetail = $.grep(serviceInfo.serviceList, e => e.serviceCd === match.params.id);
    if (serviceDetail.length > 0) {
      serviceDetail[0].enterpriseInfo = {
        enterpriseCd: serviceDetail[0].enterpriseCd,
        enterpriseName: serviceDetail[0].enterpriseName,
      };
      this.setState({
        service: serviceDetail[0],
      });
    }
    // Step 10.2.0 START
    if (enterpriseList && enterpriseList.length > 0) {
      this.setState({
        enterpriseList,
      });
    }
    // Step 10.2.0 END
  }

  /**
   * Open delete confirm dialog
   * @param {*} mdContent
   * @param {*} mdSize
   */
  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
   * Event click button cancel of delete confirm dialog
   */
  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  /**
   * Event click button ok of delete confirm dialog
   */
  onDeleteOk() {
    this.setState({ showModal: false });
    const param = {
      editType: MODE.DELETE_MODE,
      serviceInfo: {
        serviceCd: this.state.service.serviceCd,
      },
    };
    const { history } = this.props;
    this.props.dispatch(showLoading());
    this.props.dispatch(serviceEdit(param)).then(() => {
      this.props.dispatch(hideLoading());
      // Back to service top
      // STEP12.0.0 TAS-18904 START
      window.location.href = NEW_SERVICE_MANAGEMENT_URL;
      // STEP12.0.0 TAS-18904 END
    });
  }

  redirectToServicePage() {
    window.location.href = NEW_SERVICE_MANAGEMENT_URL;
  }

  /**
   * Render function of component
   */
  render() {
    const editPath = this.state.service ? `/${SERVICE}/${this.state.service.serviceCd}/edit` : '';
    const { readOnlyFlag, match } = this.props;
    const canEditService = canAccessRoute(SERVICE_EDIT);
    return (
      <div>
        {/* Step 11.0.0 START */}
        {match.url.includes(Path.SERVICE_MENU_NONE) &&
          <CustomLink
            className="margin-right-7 url-list"
            onClick={this.redirectToServicePage}
            text="サービス一覧に戻る"
            icon="bi bi-chevron-left"
          />
        }
        {/* Step 11.0.0 END */}
        <Header name="サービス情報" />
        {this.state.service &&
          <ServiceDetail
            service={this.state.service}
            enterpriseList={this.state.enterpriseList}
            displayUserType={this.props.displayUserType}
            rootFlag={this.props.rootFlag} //STEP13.0.0 TAS-21617
          />}
        <Col>
          <Form className='form-horizontal'>
            <Form.Group className="margin-top-20 text-center">
              {/* sprint_20230418 #12 START */}
              {!readOnlyFlag && canEditService && (
                <>
                  <Link className="btn btn-primary margin-10 btn-96" role="button" to={editPath}>
                    編集
                  </Link>
                  <Button
                    variant="primary"
                    className="margin-10 btn-96"
                    onClick={this.openDeleteConfirmDialog.bind(this, MSG_DEL_SERVICE, null)}
                  >
                    削除
                  </Button>
                </>
              )}
              {/* sprint_20230418 #12 END */}
            </Form.Group>
          </Form>
        </Col>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ service: state.service,
    displayUserType: state.authed.authedUser.userInfo.displayUserType,
    videoSpeedArr: state.service.videoSpeedArr,
    readOnlyFlag: state.authed.authedUser.readOnlyFlag, // sprint_20230418 #12
    rootFlag : state.authed.authedUser.rootFlag, //STEP13.0.0 TAS-21617
  },
});

export default connect(mapStateToProps)(ServiceDetailContainer);
